export const DAYS = [
  {
    label: "Lunedì",
    name: "Monday"
  },
  {
    label: "Martedì",
    name: "Tuesday"
  },
  {
    label: "Mercoledì",
    name: "Wednesday"
  },
  {
    label: "Giovedì",
    name: "Thursday"
  },
  {
    label: "Venerdì",
    name: "Friday"
  },
  {
    label: "Sabato",
    name: "Saturday"
  },
  {
    label: "Domenica",
    name: "Sunday"
  },
];

export const DATE_FORMAT = {
  FULL_DATE: "YYYY-MM-DD",
  FULL_TIME: "HH:mm:ss",
  FULL_MONTH: "MMMM",
  DAY_MONTH_YEAR: "DD MMMM YYYY",
};
